// --------------------------------------------------------------------------
// toggleExperiences.js
// --------------------------------------------------------------------------

RN.toggleExperiences = function() {

  'use strict';

  var button, options, images, columnClass, columns;

  function init() {
    button = byBehaviour('toggle-experiences');
    options = byElement('experience-options');
    images = byElement('experience-option');

    button.on('click', toggleOptionsList);
    images.on('click', toggleExperiences);

    columns = $('.timetable__column');
    columnClass = 'timetable__column--switched';
  }

  function toggleOptionsList(){
    options.toggle()
  }

  function toggleExperiences(){
    var index = $(this).parent().index();
    button.html($(this).clone());
    columns.removeClass(columnClass);
    columns.eq(index).addClass(columnClass);
    options.toggle()
  }

  return {
    init: init
  };

}();